import { render, staticRenderFns } from "./WizardStep1SelectType.vue?vue&type=template&id=1c39e6e5&scoped=true&"
import script from "./WizardStep1SelectType.vue?vue&type=script&lang=js&"
export * from "./WizardStep1SelectType.vue?vue&type=script&lang=js&"
import style0 from "./WizardStep1SelectType.vue?vue&type=style&index=0&id=1c39e6e5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c39e6e5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c39e6e5')) {
      api.createRecord('1c39e6e5', component.options)
    } else {
      api.reload('1c39e6e5', component.options)
    }
    module.hot.accept("./WizardStep1SelectType.vue?vue&type=template&id=1c39e6e5&scoped=true&", function () {
      api.rerender('1c39e6e5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/documentManagement/vistas/modals/wizard/components/WizardStep1SelectType.vue"
export default component.exports